import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 12 12\" id=\"plus\"><path d=\"M11.349 5.163H6.837V.651C6.837.446 6.558 0 6 0c-.558 0-.837.446-.837.651v4.512H.651C.446 5.163 0 5.442 0 6c0 .558.446.837.651.837h4.512v4.512c0 .205.279.651.837.651.558 0 .837-.446.837-.651V6.837h4.512c.205 0 .651-.279.651-.837 0-.558-.446-.837-.651-.837Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol